<template>
  <div>
    <input type="file" @change="changeFile">
    <button @click="upload()">上传</button>

  </div>

</template>
<script>
import axios from 'axios'
export default {
  data(){
    return{
      file:null,
    }
  },
  methods:{
    upload(){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      let formData=new FormData()
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      formData.append('file',this.file)
      console.log(formData);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。
      axios.post('api/openapi/v1/upload/file/image?access_token=34e94ecbc9f3e9c59abd64523bd0c43c70e36d0a5793c1ed11fc7e28710fe694&timestamp='+time1+'&nonce='+nonce+'&advertiser_id=9578153c35ba18cbd6a9',
        formData).then(res=>{
        // console.log(res.data)
        console.log(res.data.data.fileCode);
        console.log(res.data.data.fileFullPath);
      })
    },
    changeFile(e){
      // 获取文件信息 e.target.files
      console.log(e.target.files[0]);
      console.log(e.target.files)
      this.file=e.target.files[0];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/index1.vue